import Flickity from "flickity";

const placeholderColors = [
  "CBA97E",
  "D59858",
  "AC6B53",
  "B1A584",
  "9C7A56",
  "907D66",
  "676064",
  "7C3655",
  "B85444",
  "5F4B3F",
  "5C9598",
  "4E4247",
  "6D7645",
  "A6613C",
  "48423C",
  "017680	",
  "4F4842",
  "B4B05A",
  "ABA39A",
  "598C74",
  "83AFBC",
  "FBCB78",
  "8BA7BB",
  "D9766C",
  "D67C56",
  "7BB1B2",
  "498555",
  "98B092",
  "506B84",
  "E6955F",
  "C0B2A2",
  "A42E37",
  "2F3D4C",
  "7FAC6E",
  "015D87",
  "C4633E",
  "C1E6DF",
  "01A0B8",
  "90979B",
  "F1D3DA",
  "353337",
  "ED939D",
  "624977",
  "BFC9D0",
  "C0AFD0",
  "99324E",
  "22657F",
  "CE6C91",
  "BDC0A0",
  "91AF9D",
  "7DC1CB",
  "B4CCC9",
  "A7A094",
  "CFC291",
  "75B9AE",
  "A6D0D6",
  "BEC3BB",
  "CBB584",
  "98B092",
  "988977",
  "C8BD98",
  "9FA694",
  "6B8CA9",
  "B2C8D8",
];

const reviews = new Flickity(".reviews", {
  contain: true,
  cellAlign: "center",
  draggable: true,
  autoPlay: 5000,
  pageDots: true,
  prevNextButtons: false,
  freeScroll: false,
  wrapAround: true,
  lazyLoad: true,
  groupCells: true,
});

reviews.on(
  "staticClick.flickity",
  function (event, pointer, cellElement, cellIndex) {
    if (!cellElement) {
      return;
    }
  }
);

$(".reviews-container")
  .on("click", ".arrows.prev", () => {
    reviews.previous();
    return true;
  })
  .on("click", ".arrows.next", () => {
    reviews.next();
    return true;
  });

reviews.on("lazyLoad", function (event, cellElement) {
  const img = $(event.target);
  const placeholder = img.siblings(".placeholder");

  if (event.type === "error") {
    img.hide();
    placeholder
      .css(
        "background-color",
        "#" +
          placeholderColors[
            Math.floor(Math.random() * placeholderColors.length)
          ]
      )
      .show();
  } else {
    placeholder.hide();
  }
});
